module.exports = __webpack_public_path__ + "static/media/covidBanner.55552ce5.jpg";